"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItemShop = void 0;
var _featureToggles = require("@ori/feature-toggles");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DetailItemShop = ({
  products
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    isMrpStatementEnabled,
    isRatingsAndReviewsEnabled,
    isSubscriptionEnabled
  } = (0, _contexts.useConfiguration)();
  const {
    isLoading,
    products: productBoxData
  } = (0, _api.useGetMediaItemProducts)({
    productCodes: products
  });
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const isSingleProduct = productBoxData.length > 0 ? productBoxData.length < 2 : products.length < 2;
  const productBoxes = (0, _react.useMemo)(() => {
    if (isLoading) {
      return products.map(code => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShopItemSkeleton, {
        animation: "pulse"
      }, code));
    }
    return productBoxData.map(product => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductBox, {
      ...product,
      analyticsData: _constants2.analyticsData,
      hideRating: !isRatingsAndReviewsEnabled,
      hideSubscription: !isFeatureEnabled(_constants.OlapicFeature.PersonalSubscriptions) || !isSubscriptionEnabled,
      mrpStatementEnabled: isMrpStatementEnabled,
      withTranslationsProvider: false
    }, product.code));
  }, [isFeatureEnabled, isLoading, isMrpStatementEnabled, isRatingsAndReviewsEnabled, isSubscriptionEnabled, productBoxData, products]);
  if (products.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants2.DETAIL_ITEM_SHOP),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Header, {
      gutterBottom: true,
      variant: "h5",
      component: "h3",
      align: "center",
      color: "textPrimary",
      children: translations.shopThisLook
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductList, {
      "data-testid": getTestId(_constants2.DETAIL_ITEM_SHOP_PRODUCT_LIST),
      single: isSingleProduct,
      children: productBoxes
    })]
  });
};
exports.DetailItemShop = DetailItemShop;
